import { NgModule } from '@angular/core';
import { AmdScrollModule } from '../utilities/scroll/scroll.module';
import { AmdAppContainerComponent } from './app-container.component';
export class AmdAppContainerModule {
}
AmdAppContainerModule.decorators = [
    { type: NgModule, args: [{
                imports: [AmdScrollModule],
                declarations: [AmdAppContainerComponent],
                exports: [AmdAppContainerComponent]
            },] },
];
/**
 * @nocollapse
 */
AmdAppContainerModule.ctorParameters = () => [];
function AmdAppContainerModule_tsickle_Closure_declarations() {
    /** @type {?} */
    AmdAppContainerModule.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    AmdAppContainerModule.ctorParameters;
}
//# sourceMappingURL=app-container.module.js.map
//# sourceMappingURL=app-container.module.js.map
